import { Component, OnInit } from '@angular/core';

interface PlacementTab {
  id: string;
  label: string;
}

interface PlacementMetric {
  label: string;
  value: string;
}

interface RecruiterItem {
  sno: number;
  companyName: string;
}

interface PlacementPhotoItem {
  image: string;
  alt: string;
  caption: string;
}

@Component({
  selector: 'app-feedback-page',
  templateUrl: './feedback-page.component.html',
  styleUrls: ['./feedback-page.component.scss']
})
export class FeedbackPageComponent implements OnInit {
  selectedTab = 'tab1';

  pageTitle = 'Training and Placement Cell';
  pageSubtitle =
    'Empowering students with industry-ready skills, career guidance, placement preparation, and strong industry collaboration.';

 admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';
      
  tabs: PlacementTab[] = [
    { id: 'tab1', label: 'Overview' },
    { id: 'tab2', label: 'Placement Statistics' },
    { id: 'tab3', label: 'Training & Support' },
    { id: 'tab4', label: 'Our Recruiters' },
    { id: 'tab5', label: 'Internship' },
    { id: 'tab6', label: 'Contact' }
  ];

  heroStats: PlacementMetric[] = [
    { label: 'Final Year Students', value: '123' },
    { label: 'Students Placed', value: '102' },
    { label: 'Offers Received', value: '154' },
    { label: 'Recruiting Companies', value: '20+' }
  ];

  overviewParagraphs: string[] = [
    'The Training and Placement Cell of Fatima Michael College of Engineering and Technology plays a vital role in shaping the careers of students by connecting academic learning with industry requirements.',
    'The cell is committed to preparing students for the professional world through continuous training, skill development programs, and placement opportunities.',
    'The department organizes various activities such as aptitude training, technical skill enhancement, soft skills development, resume preparation, mock interviews, and industry interaction sessions to ensure that students are well prepared to face recruitment processes confidently.',
    'Our objective is not only to secure employment for students but also to empower them with the knowledge, confidence, and professional ethics required to succeed in their careers.'
  ];

  overviewHighlights: string[] = [
    'Bridges the gap between academic learning and industry expectations.',
    'Conducts continuous training and placement readiness programmes.',
    'Supports students through technical, aptitude, and soft-skill development.',
    'Builds confidence through mock interviews, resume preparation, and career guidance.',
    'Promotes professional ethics, employability, and long-term career success.'
  ];

  placementMetrics: PlacementMetric[] = [
    { label: 'Total Final Year Students', value: '123' },
    { label: 'Students Placed', value: '102' },
    { label: 'Total Offers Received', value: '154' },
    { label: 'Average Salary Package', value: '₹2.25 LPA' },
    { label: 'Recruiting Companies', value: '20+' }
  ];

  statisticsParagraphs: string[] = [
    'Placement Highlights – Academic Year 2025–2026 (on-going) reflect the institution’s steady commitment to career development and industry readiness.',
    'Fatima Michael College of Engineering and Technology works closely with leading companies to understand evolving industry expectations and skill requirements.',
    'Through continuous interaction with recruiters, the institution aligns its training programs with real-world industry needs. The Training and Placement Cell conducts focused skill development, aptitude training, and mock recruitment sessions to prepare students for professional careers.',
    'This strong industry–academia collaboration has enabled the college to consistently attract reputed companies and ensure successful placements for its students.'
  ];

  recruiters: RecruiterItem[] = [
    { sno: 1, companyName: 'Madura Solutions' },
    { sno: 2, companyName: 'Dotnix Technologies' },
    { sno: 3, companyName: 'Tata Electronics' },
    { sno: 4, companyName: 'Besant Technologies' },
    { sno: 5, companyName: 'Prime Vector' },
    { sno: 6, companyName: 'Delphi TVS' },
    { sno: 7, companyName: 'Cloudline Consulting' },
    { sno: 8, companyName: 'Sourcesys Technologies' },
    { sno: 9, companyName: 'Masss Glass' },
    { sno: 10, companyName: 'Rane Chennai' }
  ];

  recruiterPhotos: PlacementPhotoItem[] = [
    {
      image: 'assets/img/placement/p1.jpeg',
      alt: 'Students with offer letter from Besant Technologies, Chennai',
      caption: 'Students with offer letter from Besant Technologies, Chennai.'
    },
    {
      image: 'assets/img/placement/p2.jpeg',
      alt: 'Students with offer letters from Madura Solutions',
      caption: 'Students with offer letters from Madura Solutions.'
    }
  ];

  trainingParagraphs: string[] = [
    'The Training and Placement Cell conducts structured training programs throughout the academic year to enhance students’ employability and professional readiness.',
    'Various skill development activities are organized on a weekly basis, focusing on aptitude practice, logical reasoning, communication skills, and group discussion exercises to strengthen students’ fundamental competencies.',
    'In addition, monthly programs such as mock interviews, resume building workshops, technical skill enhancement sessions, and industry expert lectures are conducted to provide deeper exposure to recruitment expectations.',
    'These sessions help students understand real-time industry standards and prepare effectively for placement processes.',
    'Furthermore, the institution allocates special training days dedicated exclusively to placement preparation activities. On these days, intensive programs such as career guidance sessions, corporate interaction programs, and placement readiness workshops are conducted to ensure that students are well-equipped to meet industry requirements and confidently participate in campus recruitment drives.',
    'The Training and Placement Cell also provides career guidance and counselling to help students identify their strengths, explore suitable career paths, and make informed professional decisions for their future.'
  ];

  trainingHighlights: string[] = [
    'Weekly aptitude, logical reasoning, communication, and group discussion practice.',
    'Monthly mock interviews, resume building workshops, and technical skill sessions.',
    'Industry expert lectures and corporate interaction programmes.',
    'Special training days exclusively for placement preparation activities.',
    'Career guidance and counselling support for informed career decisions.'
  ];

  internshipParagraphs: string[] = [
    'The institution actively promotes internship opportunities to help students gain practical industry exposure.',
    'Through Memorandums of Understanding (MoUs) and continuous collaboration with various industries, the college facilitates internships for students across different domains.',
    'Regular discussions and partnerships with companies enable students to work on real-time projects and industry-related tasks.',
    'These internships provide valuable hands-on experience and help students understand real-world professional expectations.',
    'Such initiatives bridge the gap between academic learning and industry requirements, preparing students for successful careers.'
  ];

  contactName = 'Mr. S. Arun Babu';
  contactEmail = 'placements@fmcet.ac.in';
  contactPhone = '+91 97875 57365';

  constructor() {}

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Training and Placement Cell';
  }

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  ngOnInit(): void {}
}